import React from 'react';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Heading4 from 'components/common/subcomponents/Typography/Heading4';
import Link from 'next/link';
import FreeResourceNewIndicator from 'components/common/FreeResourceNewIndicator';

const _ResourceImg = styled('img')(({ theme: _theme }) => ({
  backgroundColor: '#B8C7CF',
  display: 'block',
  height: '100%',
  width: 'auto',
}));
const _ResourceFrame = styled('div')(({ theme: _theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  border: '50px solid #B8C7CF',
  backgroundColor: '#B8C7CF',
  borderRadius: '6px',
  height: '160px',
  width: '160px',
}));
const _ResourceSeparator = styled('div')(({ theme }) => ({
  fontWeight: 100,
  [theme.breakpoints.up('md')]: {
    fontSize: '1.25rem',
    lineHeight: '0.40rem',
    padding: '0 25px 0 30px',
  },
  [theme.breakpoints.down('md')]: {
    fontSize: '1.00rem',
    lineHeight: '0.45rem',
    padding: '0 25px 0 10px',
  },
}));
const Container = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  margin: '25px 0',
});
const PageFlow = styled('div')({
  display: 'flex',
  '@media screen and (max-width: 991px)': {
    width: '90%',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
  },
  '@media screen and (min-width: 992px)': {
    width: '100%',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'flex-start',
  },
});
const TitleBox = styled('div')({
  margin: '40px 0 20px 0',
  display: 'flex',
  justifyContent: 'center',
});
const _ImageContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  '@media screen and (max-width: 991px)': {
    display: 'none',
  },
  '@media screen and (min-width: 992px)': {
    width: '33%',
    margin: '0 20px',
  },
});
const ContentContainer = styled('div')({
  '@media screen and (max-width: 991px)': {
    width: '95%',
  },
  '@media screen and (min-width: 992px)': {
    columns: 3,
    minWidth: '33%',
    margin: '0 20px',
  },
});
const ListText = styled('div')(({ theme }) => ({
  cursor: 'pointer',
  color: theme.palette.common.black,
  fontSize: '1.125rem',
  lineHeight: '1.525rem',
  margin: '15px 0',
}));
const ResourceListItem = styled('div')({
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  width: '95%',
  borderBottom: '2px dashed #037ac4',
});

const FreeResourceList = ({ module }) => {
  const { fields } = module;

  return (
    <Box
      sx={{
        width: '98%',
        ml: 'auto',
        mr: 'auto',
        maxWidth: { sm: '540px', md: '768px', lg: '1180px', xl: '1180px' },
      }}
    >
      <Container>
        <a id={fields.anchor}>
          <TitleBox>
            <Heading4 color="#000000">{fields.title}</Heading4>
          </TitleBox>
        </a>
        <PageFlow>
          <ContentContainer>
            {fields.resources &&
              fields.resources.length > 0 &&
              fields.resources
                .filter(
                  (r) =>
                    r.fields.type.toLowerCase() === fields.type.toLowerCase(),
                )
                .sort((a, b) => {
                  if (
                    parseInt(a.fields.order, 10) > parseInt(b.fields.order, 10)
                  )
                    return 1;
                  if (
                    parseInt(a.fields.order, 10) < parseInt(b.fields.order, 10)
                  )
                    return -1;
                  return 0;
                })
                .map((item, _index) => {
                  return (
                    <Link
                      key={item.contentID}
                      href={`/free-resources/${item.fields.slug}`}
                    >
                      <ResourceListItem>
                        {item.fields?.isNew === 'true' && (
                          <FreeResourceNewIndicator>
                            NEW
                          </FreeResourceNewIndicator>
                        )}
                        <ListText>{item.fields.linkName}</ListText>
                      </ResourceListItem>
                    </Link>
                  );
                })}
          </ContentContainer>
        </PageFlow>
      </Container>
    </Box>
  );
};
export default FreeResourceList;

